/**
 * Human-facing booking ref as plain digits (e.g. 374829).
 * Strips legacy "REG-" prefix if still present; other codes (INV-…) are unchanged.
 */
export function formatBookingCodeForDisplay(code) {
  if (code == null) return '';
  const s = String(code).trim();
  if (!s) return '';
  return s.replace(/^REG-/i, '');
}
